import { StubMetadata } from '@bymason/api-base';
import { SubscriptionModel } from './types';

export const getData = (): Promise<SubscriptionModel> =>
  Promise.resolve({
    accountID: StubMetadata.AccountId,
    type: 'pay_as_you_go',
    typeSpecific: {
      target: 250000000000,
    },
  });
